var render = function render(){
  var _vm$user;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tablearea"
  }, [_c('div', {
    staticClass: "btn_area"
  }, [_vm.mode == 'edit' ? _c('div', {
    staticClass: "btn_area_left"
  }, [_vm._v(" *기본값SET "), _c('select', {
    key: _vm.selectKey,
    on: {
      "change": function ($event) {
        return _vm.settingAddRowInfo($event);
      }
    }
  }, _vm._l(_vm.getFilteredExperimentList, function (experiment, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": experiment.experimentId
      }
    }, [_vm._v(" " + _vm._s(experiment.experimentName) + " ")]);
  }), 0), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type4",
    on: {
      "click": function ($event) {
        return _vm.addRowWithValues(_vm.position.last);
      }
    }
  }, [_vm._v("ROW추가")]) : _vm._e(), _vm.mode == 'edit' && _vm.user != null && ((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.loginId) == 'SOOHYUNGPARK2' ? _c('a', {
    staticClass: "btn_type4",
    staticStyle: {
      "display": "inline-flex",
      "align-items": "center",
      "gap": "8px"
    },
    on: {
      "click": function ($event) {
        return _vm.addSampleRowWithValues(_vm.position.last, _vm.sampleRowCount);
      }
    }
  }, [_c('span', [_vm._v("임시데이터")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.sampleRowCount,
      expression: "sampleRowCount",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "width": "50px",
      "height": "28px",
      "padding": "4px 8px",
      "border": "1px solid #ddd",
      "border-radius": "4px",
      "text-align": "center",
      "font-size": "14px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "15"
    },
    domProps: {
      "value": _vm.sampleRowCount
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.sampleRowCount = _vm._n($event.target.value);
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("개 추가")])]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "btn_area_right"
  }, [_vm.mode == 'edit' ? _c('div', {
    staticClass: "checkbox_toggle"
  }, [_c('input', {
    ref: "checkbox_toggle",
    staticClass: "tg-input tg-eff",
    attrs: {
      "id": "checkbox_toggle",
      "type": "checkbox",
      "checked": "unchecked"
    },
    on: {
      "change": _vm.toggleAutoSave
    }
  }), _c('label', {
    staticClass: "tg-btn",
    attrs: {
      "for": "checkbox_toggle"
    }
  })]) : _vm._e(), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type1",
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("저장")]) : _vm._e(), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type4",
    on: {
      "click": _vm.callVersionHistory
    }
  }, [_vm._v("버전이력")]) : _vm._e(), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.callResultConfrim
    }
  }, [_vm._v("엑셀업로드")]) : _vm._e(), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.excelTemplateDownLoad
    }
  }, [_vm._v("엑셀다운로드")]) : _vm._e(), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.excelVocabClassDownLoad
    }
  }, [_vm._v("엑셀다운로드(표준어휘 체계)")]) : _vm._e(), _vm.mode == 'readOnly' ? _c('a', {
    staticClass: "btn_type5",
    on: {
      "click": _vm.editExperiment
    }
  }, [_vm._v("수정모드")]) : _vm._e(), _vm.mode == 'edit' ? _c('a', {
    staticClass: "btn_type5",
    on: {
      "click": _vm.endEditExperiment
    }
  }, [_vm._v("읽기모드")]) : _vm._e()])]), _c('HotTableMain', {
    ref: "handsomeRef",
    attrs: {
      "settings": _vm.hotSettings,
      "licenseKey": '6c578-61cf1-e8cf5-b453c-1f850'
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.editStatusAlert,
      expression: "editStatusAlert"
    }],
    staticClass: "modalPopupLayout active"
  }, [_c('div', {
    staticClass: "contentWrap"
  }, [_c('h2', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.editStatusTitle))]), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center",
      "width": "300px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.editStatusContent)
    }
  })]), _c('div', {
    staticClass: "ctrl",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "sm_btn color_2",
    on: {
      "click": function ($event) {
        return _vm.$router.go(_vm.$router.currentRoute);
      }
    }
  }, [_vm._v("확인")])])])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading || _vm.savingLoading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }